var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters"},[_c('portal',{attrs:{"to":"cm-filters-chips"}},[_c('cm-filters-chips',{attrs:{"model":_vm.model},on:{"remove":_vm.removeFilter}})],1),_c('cm-filters-list',{attrs:{"filters":_vm.filters},on:{"filterChanged":_vm.startFiltering}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }